import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { StatusCodeType } from '@fi-shared/types/status-code-type';
import { tap } from 'rxjs/operators';
import { AppTextService } from '@fi-shared/app-text';
import { FiBackendService, IBackendErrorData } from '@fi-shared/fi-backend/fi-backend.service';
import { ActionFailureReasonCode } from '@fi-shared/types/action-failed-reason-code';

@Injectable()
export class FiHttpAuthInterceptor implements HttpInterceptor {
    constructor(
        @Inject(SessionService) private sessionService,
        private fiBackend: FiBackendService,
        private appTextService: AppTextService,
    ) {}

    private resetSessionAndReload() {
        this.sessionService.resetSession();
        window.location.href = '/';
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req).pipe(
            tap(
                () => {},
                (err: IBackendErrorData) => {
                    if (err && this.fiBackend.isExternalApiUrl(err.url)) return;

                    const reasonCode = err?.error?.Reason;
                    const status = err?.status;
                    if (
                        reasonCode === ActionFailureReasonCode.General_UpgradeInProcess ||
                        reasonCode === ActionFailureReasonCode.User_TokenExpired ||
                        status === StatusCodeType.Unauthorized
                    ) {
                        this.resetSessionAndReload();
                    } else if (reasonCode === ActionFailureReasonCode.User_TokenDeactivated) {
                        window.alert(this.appTextService.get('common.login_error_account_deactivated'));
                        this.resetSessionAndReload();
                    } else if (reasonCode === ActionFailureReasonCode.General_UnAuthorizedModule) {
                        // todo: uncomment code when statitic module in enabled in backend ?
                        //$window.location.href = "/";
                    } else if (status === StatusCodeType.PaymentRequired) {
                        window.location.href = 'http://cyberspace.se/invoice-not-paid.htm';
                    }
                },
            ),
        );
    }
}
